import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Subject, zip } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { StoreService } from 'src/app/store/service/store.service';
import { WEBSOCKET_TOPIC_USER_FILES } from '../const';
import { NOTIFICATIONS_STORE_NAME, NotificationType, Notification } from '../model/notification';
import { NotificationService } from './notification.service';
import { ToastService } from './toast.service';
import { UserProfileService } from './user-profile.service';
import { WebsocketClient } from './websocket-client.service';
import { UserFile } from 'src/app/files/model/user-file';
import { UserFileStatus } from 'src/app/files/model/user-file-status';

@Injectable({
  providedIn: 'root'
})
export class UserFilesService {

  private userFileChangeSubscription = new Subject<UserFile>();
  userFileChange$ = this.userFileChangeSubscription.asObservable();

  constructor(private websocketClient: WebsocketClient, private userProfile: UserProfileService, private toast: ToastService,
              private storeService: StoreService, private notificationService: NotificationService) { }

  init(): void {
    this.websocketClient.websocketConnectionConnected$
      .pipe(filter(connected => connected))
      .subscribe(() => this.connectToUserFilesWebsocket());
  }

  private connectToUserFilesWebsocket(): void {
    this.userProfile.updateUserProfile$
      .pipe(take(1))
      .subscribe(profile => {
        this.websocketClient.subscribe(WEBSOCKET_TOPIC_USER_FILES + profile.username)
          .pipe(map((response) => plainToClass(UserFile, response)))
          .subscribe(userFile => this.onNewUserFile(userFile));
      });
  }

  private onNewUserFile(userFile: UserFile): void {
    if (userFile.status == UserFileStatus.DONE || userFile.status == UserFileStatus.FAILED) {
      const severity = userFile.status == UserFileStatus.DONE ? 'info' : 'error';
      zip(this.notificationService.getUserFileTitle(userFile), this.notificationService.getUserFileText(userFile))
        .subscribe(([title, message]: [string, string]) => this.toast.showDataToast(title, message, { url: '/files/reports' }, severity));
      this.storeService.store<Notification>(NOTIFICATIONS_STORE_NAME, [
        { type: NotificationType.FILE, time: new Date(), data: userFile, url: '/files/reports' }
      ]);
      this.userFileChangeSubscription.next(userFile);
    }
  }

}
